export const JsonSampleData = [
  {
    SettingsListing: {
      row: [
        {
          Setting: {
            SettingId: "1",
            Name: "Collections",
            Link: "/app/RecordListing/collections"
          }
        },
        {
          Setting: {
            SettingId: "2",
            Name: "Taxonomies",
            Link: "/app/RecordListing/taxonomies"
          }
        }
      ],
    },
    InvoiceListing: {
      row: [
        {
          InvoiceId: "1",
          InvoiceNumber: "3432767",
          TotalAmount: "23.45",
          TotalPaid: null,
          InvoiceDueDate: "2022-07-29 00:00:00.0000000 +00:00",
          CreatedDate: "2022-07-29 00:00:00.0000000 +00:00",
          OrderId: "1",

          ContactId: "101",
          DisplayName: "Lucy Bisson",
          LastName: "Bussion",
          FirstName: "Lucy",
          DisplayId: "198253",
          PrimaryAddress_EnumStateProvince: 1,
          PrimaryAddress_City: "Red Deer",
          PrimaryAddress_EnumCountryRegion: 124,
          PrimaryPosition: "Director",
          PrimaryOrganization: "Acme Inc",
          BatchId: "20230112-080549",
          ContactMethod: [
            {
              ContactMethodGuid: "8cc4691f-c957-e511-80be-00155d010f90",
              IsPreferred: "True",
            },
            {
              ContactMethodGuid: "c350a183-746b-e511-80c0-00155d010f90",
              IsPreferred: "False",
            },
          ],
          Address: [
            {
              ContactMethodGuid: "8cc4691f-c957-e511-80be-00155d010f90",
              City: "Ottawa",
              EnumCountryRegion: "Canada",
            },
            {
              ContactMethodGuid: "c350a183-746b-e511-80c0-00155d010f90",
              City: "Toronto",
              EnumCountryRegion: "Canada",
            },
          ],
        },


      ]
    },
    OrganizationListing: {
      row: [
        {
          Contact: {
            ContactId: "1",
            Name: "Organization 1",
          }
        },
        {
          Contact: {
            ContactId: "2",
            Name: "Organization 2",
          }
        }
      ],
    },
    ContactTypeListing: {
      row: [
        {
          Node: {
            NodeId: "1",
            Name: "CPA Complimentary Membership",
          }
        },
        {
          Node: {
            NodeId: "2",
            Name: "CPA Fellow",
          }
        },
        {
          Node: {
            NodeId: "3",
            Name: "CPA Honorary Life Fellow",
          }
        },
        {
          Node: {
            NodeId: "4",
            Name: "CPA Honorary Life Member",
          }
        },
        {
          Node: {
            NodeId: "4",
            Name: "CPA International Affiliate",
          }
        },
        {
          Node: {
            NodeId: "4",
            Name: "CPA International Student Affiliate",
          }
        },
        {
          Node: {
            NodeId: "4",
            Name: "CPA Member",
          }
        }
      ],
    },
    LocationListing: {
      row: [
        {
          Address: {
            id: "1",
            Text: "Ottawa, Canada",
          }
        },
        {
          Address: {
            id: "2",
            Text: "Toronto, Canada",
          }
        },
        {
          Address: {
            id: "3",
            Text: "New York, USA",
          }
        }
      ],
    },
    AppListing: {
      row: [
        {
          Setting: {
            SettingId: "1",
            Name: "SurveyMonkey",
            Link: "/app/RecordListing/collections"
          }
        }
      ],
    }
  },

];

export const PageData = {
  page: {
    content_item_id: 101,
    parent_content_item_id: null,
    weight: 1,
    title: 'Overview',
  },
  layoutZones: [
    {
      layout_zone_id: 501,
      row_number: 1,
      column_number: 1,
      zone_width: 8,
      for_record_type: 999, //page=999, enumRecordType for page is not created yet
      for_record_id: 101 //101 = page id			
    },
    {
      layout_zone_id: 502,
      row_number: 1,
      column_number: 2,
      zone_width: 4,
      for_record_type: 999, //page=999, enumRecordType for page is not created yet
      for_record_id: 101 //101 = page id			
    },
  ],
  sections: [
    {
      content_item_id: 201,
      weight: 1,
      title: 'About',
      JSONMetaData: {
        layout_zone_id: 501
      }
    },
    {
      content_item_id: 202,
      weight: 2,
      title: 'Pinned',
      JSONMetaData: {
        layout_zone_id: 501
      }
    },
    {
      content_item_id: 203,
      weight: 3,
      title: 'Awards',
      JSONMetaData: {
        layout_zone_id: 501
      }
    },
    {
      content_item_id: 204,
      weight: 4,
      title: 'Committees',
      JSONMetaData: {
        layout_zone_id: 501
      }
    },
    {
      content_item_id: 205,
      weight: 5,
      title: 'Current Membership',
      JSONMetaData: {
        layout_zone_id: 501
      }
    },
    {
      content_item_id: 206,
      weight: 6,
      title: 'Latest Activity',
      JSONMetaData: {
        layout_zone_id: 501
      }
    },
    {
      content_item_id: 207,
      weight: 1,
      title: 'Primary Contact Information',
      JSONMetaData: {
        layout_zone_id: 502
      }
    },
    {
      content_item_id: 208,
      weight: 2,
      title: 'Journeys',
      JSONMetaData: {
        layout_zone_id: 502
      }
    },
  ]
}


export const Blocks = [
  {
    content_item_id: 301,
    parent_content_item_id: 201,
    weight: 1,
    JSONMetaData: {
      block_type: 3,
      process_id: 401,
      is_about: true //this property will be removed when data retrieved using sproc execution is suported
    }

  },
  {
    content_item_id: 302,
    parent_content_item_id: 202,
    weight: 1,
    JSONMetaData: {
      block_type: 5,
      process_id: 402,
    }

  },
  {
    content_item_id: 303,
    parent_content_item_id: 203,
    weight: 1,
    JSONMetaData: {
      block_type: 1,
      process_id: 403,
    }

  },
  {
    content_item_id: 304,
    parent_content_item_id: 204,
    weight: 1,
    JSONMetaData: {
      block_type: 1,
      process_id: 404,
    }

  },
  {
    content_item_id: 305,
    parent_content_item_id: 205,
    weight: 1,
    JSONMetaData: {
      block_type: 3,
      process_id: 405,
    }

  },
  {
    content_item_id: 306,
    parent_content_item_id: 206,
    weight: 1,
    JSONMetaData: {
      block_type: 4,
      process_id: 406,
    }

  },
  {
    content_item_id: 307,
    parent_content_item_id: 207,
    weight: 1,
    JSONMetaData: {
      block_type: 2,
      process_id: 407,
    }

  },
  {
    content_item_id: 308,
    parent_content_item_id: 208,
    weight: 1,
    JSONMetaData: {
      block_type: 6,
      process_id: 408,
    }

  },
]

export const webBuilder = {}